class ArticleNav extends HTMLElement {
  constructor() {
    super();

    this.headings = document.querySelectorAll('.article-content h1, .article-content h2, .article-content h3');
    this.wrapper = this.closest('.article-subnav');
    this.rendered = false;
  }

  btnsEventListeners() {
    this.btns.forEach(btn => btn.addEventListener('click', (e) => this.scrollToAnchor(e)));
  }

  connectedCallback() {
    if (this.rendered) return;
    this.renderList(this.collectHeadings());
    this.renderOverview();
    this.btns = this.querySelectorAll('button');
    this.btnsEventListeners();
    this.wrapper.setAttribute('aria-hidden', false)
    this.rendered = true;
  }

  collectHeadings() {
    const headingTextNodes = [];

    this.headings.forEach(heading => {
      if (heading.querySelector('iframe')) return;
      if (heading.closest('.card-article')) return;
      if (heading.closest('.article-content__products')) return;
      if (heading.closest('.article-quote__wrapper')) return;

      const headingText = heading.textContent;
      if (headingText.trim() === '') {
        heading.remove();
        return;
      }

      heading.setAttribute('data-anchor', this.handleizeString(headingText.trim()));
      heading.setAttribute('id', this.handleizeString(headingText.trim()));

      headingTextNodes.push({
        nodeName: heading.nodeName,
        text: headingText.trim()
      });
    })

    return headingTextNodes;
  }

  renderList(headingTextNodes) {
    headingTextNodes.forEach(headingText => {
      const button = document.createElement('button');
      const spyElement = document.createElement('scroll-spy');
      
      button.textContent = headingText.text;
      button.classList.add(`button-${headingText.nodeName.toLowerCase()}`);
      button.setAttribute('data-scroll-to', this.handleizeString(headingText.text));
      button.setAttribute('data-scroll-spy', `#${this.handleizeString(headingText.text)}`);
      button.setAttribute('data-scroll-trigger-point', 'bottom');
      button.setAttribute('data-scroll-spy-desktop', '');
      spyElement.setAttribute('data-scroll-spy-container', '#articleWrapper');

      spyElement.appendChild(button);
      this.insertAdjacentElement('beforeend', spyElement);
    })
  } 

  renderOverview() {
    const overviewElement = document.querySelector('.article-content *:first-child');
    if (!overviewElement || overviewElement.tagName.toLowerCase() !== 'blockquote') return;
    const button = document.createElement('button');
    const spyElement = document.createElement('scroll-spy');
    const overviewText = overviewElement.textContent.trim().slice(0, 25);

    button.textContent = 'Overview';
    button.classList.add('button-overview');
    button.classList.add('is-selected');
    button.setAttribute('data-scroll-to', overviewText);
    button.setAttribute('data-scroll-spy', `#${this.handleizeString(overviewText)}`);
    button.setAttribute('data-scroll-trigger-point', 'bottom');
    button.setAttribute('data-scroll-spy-desktop', '');
    spyElement.setAttribute('data-scroll-spy-container', '#articleWrapper');

    overviewElement.setAttribute('data-anchor', overviewText);
    overviewElement.setAttribute('id', this.handleizeString(overviewText));

    spyElement.appendChild(button);
    this.insertAdjacentElement('afterbegin', spyElement);
  }

  scrollToAnchor(e) {
    const target = document.querySelector(`[data-anchor="${e.target.getAttribute('data-scroll-to')}"]`);

    if (!target) return;

    const targetRect = target.getBoundingClientRect();
    const topOffset = window.innerWidth < 768 ? 110 : 130;

    window.scrollTo({
      top: targetRect.top + window.scrollY - topOffset,
      left: 0,
      behavior: 'smooth',
    });    
  }

  handleizeString(str) {
    return str.toLowerCase().replace(/[^\w\u00C0-\u024f]+/g, "-").replace(/^-+|-+$/g, "");
  }
}

if (!customElements.get('article-nav')) {
  customElements.define('article-nav', ArticleNav);
}

class ArticleHelper {
  constructor() {
    this.container = document.querySelector('.article-content__wrapper');
  }

  clearElements() {
    // replace white-space symbols only on elements with a single text node
    this.container.querySelectorAll('.article-content *').forEach(element => {
      if (element.childNodes.length === 1 && element.childNodes[0].nodeName === '#text') {
        if (!element.textContent.includes(String.fromCharCode(160))) return;
        element.textContent = element.textContent.replaceAll(String.fromCharCode(160), ' ');
      }
    });

    // remove empty elements
    this.container.querySelectorAll('.article-content > *').forEach(element => {
      if (element.textContent.trim() === '' 
        && !element.querySelector('img, iframe, video, svg') 
        && element.nodeName !== 'IMG' 
        && element.nodeName !== 'IFRAME' 
        && element.nodeName !== 'VIDEO' 
        && element.nodeName !== 'svg'
      ) {
        element.remove();
      }
    });  
  }

  unpackArticleContentElements() {
    // unpack quotes and products from their 'wrappers' 
    // (this so-called wrapper is being created automatically when in liquid you are replacing content)
    // DO NOT UNWRAP ELEMENTS WITH VIDEOS !!! (this cause double initialization of video-background component)
    this.container.querySelectorAll('.article-quote__wrapper, .article-content__products').forEach(element => {
      if (!element.querySelector('& > i, & > em, & > b, & > p')) return;
      element.innerHTML = element.querySelector('& > i, & > em, & > b, & > p').innerHTML;
    })   
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const articleHelper = new ArticleHelper();
  articleHelper.clearElements();
  articleHelper.unpackArticleContentElements();
});